// src/components/latest-results/ENTTestRow.jsx
const MAX_DEFAULT_IMAGES = 5;

export default function ENTTestRow({
  detail,
  images = [],
  onAddImage,
  onRemoveImage,
  onRemoveAll,
  maxImages = MAX_DEFAULT_IMAGES,
}) {
  const canAddMore = images.length < maxImages;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <p className="text-lg font-semibold text-[#845BB3]">{detail?.name}</p>
          <p className="text-xs text-gray-500">
            {detail?.unit || ""}{" "}
            {detail?.referenceRange ? `(${detail.referenceRange})` : ""}
          </p>
        </div>
        <button
          onClick={onAddImage}
          disabled={!canAddMore}
          className="px-4 py-2 bg-green-600 text-white rounded-md text-sm disabled:bg-gray-300"
        >
          {canAddMore ? "Add Images" : "Limit Reached"}
        </button>
      </div>

      {images.length === 0 ? (
        <p className="text-sm italic text-gray-500">
          No ENT images uploaded yet. Click &quot;Add Images&quot; to capture up
          to {maxImages} images.
        </p>
      ) : (
        <ul className="space-y-3">
          {images.map((src, idx) => (
            <li
              key={`${detail?.ParameterID || "ent"}-${idx}`}
              className="flex items-center gap-4 p-3 rounded-xl border border-[#E0DDF5] bg-[#F8F6FF]"
            >
              <div className="relative w-28 h-20 rounded-lg overflow-hidden border border-white shadow-sm">
                <img
                  src={src}
                  alt={`ENT ${idx + 1}`}
                  className="w-full h-full object-cover"
                />
                <button
                  type="button"
                  className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-6 h-6 text-xs shadow-lg"
                  onClick={() => onRemoveImage?.(idx)}
                >
                  ×
                </button>
              </div>

              <div className="flex flex-col gap-2">
                <p className="text-sm font-medium text-[#845BB3]">
                  Image {idx + 1}
                </p>
                <button
                  type="button"
                  onClick={() => onRemoveImage?.(idx)}
                  className="px-3 py-1 text-xs rounded-md bg-red-100 text-red-600 hover:bg-red-200 transition"
                >
                  Delete Image
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}

      {images.length > 0 && (
        <div className="flex items-center justify-between flex-wrap gap-3">
          <p className="text-xs text-gray-500">
            {images.length}/{maxImages} images uploaded.
          </p>
          <button
            type="button"
            onClick={onRemoveAll}
            className="px-4 py-2 text-sm rounded-md bg-red-500 text-white hover:bg-red-600"
          >
            Delete All Images
          </button>
        </div>
      )}
    </div>
  );
}
